import './App.css';
import Card from './components/Card';

function App() {
  return (
    <div className="App">
     <h1>Ofertas do Dia</h1>
     <Card />
    </div>
  );
}

export default App;
